export default "__VITE_ASSET__DAwhaNY1__"